import { IPublicClientApplication } from "@azure/msal-browser";
import Axios from "../../Config/API";
import Service from "../../Service";

const request = {
    scopes: ["User.Read"],
};

export function GetTokenMSAL(instance: IPublicClientApplication) {
    return instance.acquireTokenPopup(request);
}

export function FazerLoginADService(token: string, ID_ORG: string) {
    return Service(
        Axios.post(`/Home/Authenticate/loginad?ID_ORG=${ID_ORG}`, { token })
    );
}

export function FazerLoginOrganizacaoADService(token: string) {
    return Service(
        Axios.post(`/Home/Authenticate/loginorganizacaoad?`, { token })
    );
}
